import "../css/Faqs.css";

const faqs = [
  {
    q: "Do you take reservations?",
    a: "We operate on a walk-in basis. If you’re visiting in a group, arriving earlier in the day is recommended.",
  },
  {
    q: "Do you offer plant-based milk options?",
    a: "Yes. We offer oat, almond, and soy milk across all our coffee drinks.",
  },
  {
    q: "Is Neo Café suitable for remote work?",
    a: "Absolutely. Many guests work from our café, especially during mornings and afternoons.",
  },
  {
    q: "Do you have free Wi-Fi?",
    a: "Yes. Complimentary Wi-Fi is available for all our guests.",
  },
  {
    q: "Are pets allowed?",
    a: "Pets are welcome in our outdoor seating areas.",
  },
  {
    q: "Do you host private events?",
    a: "Yes. Please reach out via our contact page for private bookings and collaborations.",
  },
];

const Faqs = () => {
  return (
    <main className="faqs">

      {/* HERO */}
      <section className="faqs-hero">
        <h1>FAQs</h1>
        <p>Answers to common questions</p>
      </section>

      {/* INTRO */}
      <section className="faqs-intro">
        <p>
          We believe clarity makes the experience better.
          Here are a few things people often ask us.
        </p>
      </section>

      {/* LIST */}
      <section className="faqs-list">
        {faqs.map((item, index) => (
          <div key={index} className="faq-item">
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </section>

      {/* FINAL */}
      <section className="faqs-final">
        <p>
          Still curious?<br />
          We’re always happy to help.
        </p>
      </section>

    </main>
  );
};

export default Faqs;
